import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';
import { AngularSplitModule } from 'angular-split';

import { GroupRouteGuardService } from 'app/services/group-route-guard.service';
import { ConfigurationSharedModule } from '../configuration/configuration-shared.module';
import { AppSharedModule } from '../../app-shared.module';
import {
  AuthGuardService,
  NotExecutiveGuardService,
} from '../../providers/bridge-api/auth.service';
import { ConfigurationRouteService } from '../../providers/semantria-api/configuration-route.service';
import { ConfigurationRouteConfigurationsComponent } from './components/configuration-route-configurations/configuration-route-configurations.component';
import { ConfigurationRouteDetailsFormComponent } from './components/configuration-route-details-form/configuration-route-details-form.component';
import { ConfigurationRouteEditComponent } from './components/configuration-route-edit/configuration-route-edit.component';
import { ConfigurationSelectorListComponent } from './components/configuration-selector-list/configuration-selector-list.component';
import { CreateConfigurationRouteDrawerComponent } from './components/create-configuration-route-drawer/create-configuration-route-drawer.component';
import { EditConfigurationsDialogComponent } from './components/edit-configurations-dialog/edit-configurations-dialog.component';
import { IncludedConfigurationsFormComponent } from './components/included-configurations-form/included-configurations-form.component';
import { ResponseTypeFormComponent } from './components/response-type-form/response-type-form.component';
import { ConfigurationRouteListComponent } from './pages/configuration-route-list/configuration-route-list.component';
import { ConfigurationRouteViewComponent } from './pages/configuration-route-view/configuration-route-view.component';
import { CanDeactivateConfigurationRouteEditService } from './services/can-deactivate-configuration-route-edit.service';
import { ConfigurationRouteListService } from './services/configuration-route-list.service';

@NgModule({
  declarations: [
    ConfigurationRouteListComponent,
    ConfigurationRouteViewComponent,
    ConfigurationRouteEditComponent,
    ConfigurationRouteConfigurationsComponent,
    ResponseTypeFormComponent,
    ConfigurationRouteDetailsFormComponent,
    IncludedConfigurationsFormComponent,
    CreateConfigurationRouteDrawerComponent,
    ConfigurationSelectorListComponent,
    EditConfigurationsDialogComponent,
  ],
  imports: [
    AppSharedModule,
    ConfigurationSharedModule,
    AngularSplitModule,
    RouterModule.forRoot([
      {
        canActivate: [AuthGuardService, NotExecutiveGuardService, GroupRouteGuardService],
        path: 'groups/:groupId/configuration-routes',
        component: ConfigurationRouteListComponent,
        children: [
          {
            canDeactivate: [CanDeactivateConfigurationRouteEditService],
            path: ':routeId',
            component: ConfigurationRouteViewComponent,
          },
        ],
      },
    ]),
  ],
  providers: [
    ConfigurationRouteService,
    ConfigurationRouteListService,
    CanDeactivateConfigurationRouteEditService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ConfigurationRouteModule {}
